module.exports = __webpack_public_path__ + "static/media/comertial-suport.013ff304.webp";